import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import * as THREE from 'three';

export class Obj3d {

	private _contador = 0;

	// RUTA
	private _path = 'assets/3D/';

	// Lista con los datos básicos de cada poste.
	// estado   :: (0) No está cargado ni cargandose. (-1) Está cargandose. (1) Está cargado y disponible.
	// archivo  :: Nombre de los archivos archivo.mtl y archivo.obj .
	// material :: Material creado del archivo mtl.
	// mesh     :: Objeto 3D contenido en el archivo obj.
	protected _data = {}; //D60: { estado: 0, archivo: 'PosteD60', carpeta: 'postes', mesh: undefined, length: 0 },

	// Indica si debe mostrar mensajes por la consola.
	private _debug = false;

	// Mensage que algunos métodos usan para cominucar resultados.
	public mensaje: string;

	constructor(path: string, debug: boolean) {
		this._debug = debug;
		this._contador = 0;
		this._path = path;
	}

	// Devuelve true si está cargando modelos.
	public get cargando(): boolean { return this._contador > 0; }

	public cargar3D(name: string) {
		let _obj3d = this._data[name];
		if (this._debug) //console.log('Entra cargar3D("' + name + '")');
		if (!_obj3d) {
			this.mensaje = 'cargar3D(' + name + ') -> objeto 3D desconocido.';
			if (this._debug) console.log(this.mensaje);
			return;
		}

		// Si esta disponible para ser descargado.
		if (_obj3d.estado === 0) {
			//this.mensaje = "Iniciada carga de objeto 3D '" + name + "'";
			if (this._debug) //console.log(this.mensaje);
			_obj3d.estado = -1; // Marcar que está cargando.

			// Contar una nueva carga.
			this._contador++;

			// Cear el material partiendo del archivo mtl.
			let mtlLoader = new MTLLoader();
			let url = this._path + _obj3d.carpeta + '/' + _obj3d.archivo + '.mtl';
			mtlLoader.load(url, (materials) => {
				materials.preload();

				// Cargar el objeto.
				let objLoader = new OBJLoader();
				objLoader.setMaterials(materials);
				// Transparentes con dos caras. 'TRA_'.
				let mats = objLoader.materials.getAsArray();
				for (let m of mats) {
					if (m.name.startsWith('TRA_')) {
						m.transparent = true;
						m.blending = THREE.NormalBlending;
						//ESPRRIVISA-90: Con este parámetro evitamos problema de visualización de texturas transparentes en funcion de la orientación de la cámara
						//cuando los tramos definen ángulos cerrados.
						m.depthWrite = false;
						if(m.name.includes('BACKSIDE')) {
							//JGG: Caso del BasNature con dos planos solapados y las normales invertidas
							console.log('THREE.BackSide')
							m.side = THREE.BackSide;
						} else {
							m.side = THREE.DoubleSide;
						}
					}
				}

				objLoader.load(this._path + _obj3d.carpeta + '/' + _obj3d.archivo + '.obj', (obj) => {
					_obj3d.mesh = obj;
					_obj3d.mesh.updateMatrix();
					_obj3d.mesh.matrixAutoUpdate = true;

					this.mensaje = 'Objeto 3D "' + name + '" creado con exito.';
					if (this._debug) console.log(this.mensaje);
					_obj3d.estado = 0; // Objeto 3D cargado con exito.

					this._contador--; // Descontar una carga.
				},
					undefined,
					(e) => {
						this.mensaje = e.message;
						if (this._debug) console.error(this.mensaje);
						_obj3d.estado = 0; // Se intento cargar pero obtuvo errores.
						this._contador--; // Descontar una carga.
					});
			},
				xhr => { },
				(error) => {
					this.mensaje = error.message;
					if (this._debug) console.error(this.mensaje);
					this._contador--;
				});
		}
		else if (_obj3d.estado === 1) {
			this.mensaje = 'El objeto 3D "' + name + '" ya está cargado.';
			if (this._debug) console.log(this.mensaje);
		}
		else if (_obj3d.estado === -1) {
			this.mensaje = 'El objeto 3D "' + name + '" se está cargando.';
			if (this._debug) console.log(this.mensaje);
		}
	}

	public clone(name: string): any {
		if (!name) return undefined;
		let obj3d = this._data[name];
		// TODO COLOR
		if (obj3d && obj3d.mesh) return obj3d.mesh.clone(true);
		return undefined;
	}

	// Devuelve la longitud del objeto 3D, no es necesario que este cargado.
	public length(name: string): number {
		// Si el parámetro 'name' u objeto3D no existe retorna 0.
		if (!name || !this._data[name]) return 0;
		return this._data[name].length;
	}
}
